<template>
	<div>
		<!-- {{ wHeigt }} -->
		<div class="product" :style="{marginTop:`${bannerTop}px`}">
			<span class="top01"></span>
			<div class="product-wrapper">
				<div class="header-img">
					<img class="header-img1" src="https://file.40017.cn/hubble/alliance/icon-share-tc1.png" alt="">
					<div class="header-img2">同程旅行订酒店机票火车拼车门票</div>
					<img class="header-img3" src="https://file.40017.cn/hubble/alliance/icon-share-gufang1.png" alt="">
				</div>
				<div class="header-title">
					{{ shareDesc }}
				</div>
				<div class="header-banner">
					<div v-if="!imgSrc" :style="{height: `${bannerHeight}px !important`}" class="poster-loading-wrapper">
                          <div class="poster-loading"></div>
                          <div class="poster-loading-txt">图片获取中...</div>
                      </div>
					<img v-if="imgSrc" class="banner-img taro-img__mode-aspectfill" 
					:style="{height: `${bannerHeight}px`}" :src="imgSrc" alt="">
				</div>
				<div class="header-logo">
					<img src="https://file.40017.cn/hubble/alliance/icon-mp.png" alt="">
					<div class="header-logo-txt">小程序</div>
				</div>

			</div>
		</div>

		<div class="share-btn-wrapper">
			<div class="share-btn" @click="share">立即分享给好友</div>
		</div>

		<div class="mask" v-if="showBottom" @click="closeShare"></div>

		<div class="bottom" v-if="showBottom">
			<div class="bottom-close-wrapper">
				<div class="bottom-close" @click="closeShare">
					<img src="https://file.40017.cn/hubble/alliance/icon-delete.png" alt="">
				</div>
			</div>
			<div class="bottom-img-wrapper">
				<div class="bottom-img">
					<img src="https://file.40017.cn/hubble/alliance/icon-weixin.png" alt="">
				</div>
				<div class="bottom-txt">发送给好友</div>
			</div>
		</div>


	</div>
</template>

<script>
//配置统一在cps/config中更改
import { API_PATHS } from "../util/cps/config";
const API = {
	ProductDetail: API_PATHS.ProductDetail, // 历史订单页面配置。
	ProductTarget: API_PATHS.ProductTarget, // 分享页面地址
};
import axios from "axios";
import {
		openUrl,
		getCookie
	} from '../util/tool.js'
export default {
	name: "list",
	components: {},
	data() {
		return {
			bannerTop: 150,
			bannerHeight:220,
			wHeigt:0,
			routeData:null,
			Correspond: null,
			showBottom: false,
			imgSrc: "",
			shareDesc: "我发现了一家性价比超高的酒店，听说现在预订还有优惠~",
			mppath:"/page/home/webview/webview", //小程序地址
			h5path:"" //小程序内嵌H5地址
		};
	},
	//http://10.181.124.198:3007/#/cpsShare?token=993c51af08c04f00828d15461de73d59&productId=10075707&productBizType=0&skuId=0&productType=10
	async mounted() {
		this.wHeigt = window.innerHeight
		//根据屏幕高度决定海报高度
		let minH = 130
		this.bannerHeight = this.wHeigt/4
		if(this.bannerHeight < minH) {
			this.bannerHeight = minH
		}
		this.bannerTop = this.wHeigt/7

		document.title = "产品分享"
		//一开始信息由于过快会打印不到！
		//1.初始化
		this.Correspond = new Correspond({
			unionId: this.generateRandomString(10),//用户unionId === 随机生成
			channelId: 'cpsshare',//h5通道标识，与上面webview的isSocket值相同
			openEdition: true,//2.0.0版本支持
			openHash: false,//2.0.0版本支持
			version: '2',//2.0.0版本支持
			monitor: 'isSocket',//2.2.0支持，参数isSocket或者isRdUserId
		});
		console.log('this.Correspond ===========', this.Correspond)

		await this.getDetail()
		//初始化
		setTimeout(()=>{
			console.log('等2s再打印=>this.$route.query', this.$route.query)
		},2000)
		//https://wx.t.17u.cn/ordercenterfront/#/cpsShare?token=55a599ac9da0435bb547136eb83c27d8&productId=10075707&productBizType=11&skuId=0001&productType=10
		//点击跳转？
		setTimeout(()=>{
			// this.redirectGetWx()
		},100)
	},
	watch: {},
	methods: {
		//TODO 
		//1.cookie中拿信息
		//2.接口请求，判断是否过期
		//3.过期继续进行重定向
		//延迟打印，有些console被延迟打印
		redirectGetWx(){
			console.log('cookies================')
			//wxuser
			let wxuser = getCookie('WxUser');
			if(wxuser){
				setTimeout(()=>{
					console.log('等待2s打印：wxuser=====', wxuser)
				},2000)
			}else{
				console.log('定向中=====')
				let productId = this.$route.query.productId
				let productBizType = this.$route.query.productBizType
				let skuId = this.$route.query.skuId
				let productType = this.$route.query.productType
				let token = this.$route.query.token
				let sharePath = `${location.origin}${location.pathname}#/cpsShare?token=${token}&productId=${productId}&productBizType=${productBizType}&skuId=${skuId}&productType=${productType}`
				console.log('sharePath', sharePath)
				//带参数的需要encodeurl
				let encodeurl = encodeURIComponent(sharePath)

				let hrefurl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3827070276e49e30&redirect_uri=https://wx.17u.cn/flight/getopenid.html?url=${encodeurl}&showwxpaytitle=1&response_type=code&scope=snsapi_base&state=123&connect_redirect=1#wechat_redirect`
				
				console.log('encodeurl', encodeurl)
				window.location.href= hrefurl
			}
		},
		getDetail() {
			console.log('this.$route.query', this.$route.query)
			let productId = this.$route.query.productId
			let productBizType = this.$route.query.productBizType
			let skuId = this.$route.query.skuId
			let productType = this.$route.query.productType
			let token = this.$route.query.token

			let requestdata = {
				productId,
				productBizType,
				skuId,
				productType
			};
			axios
				.post(API.ProductDetail, requestdata, {
					timeout: 5000,
					headers: {
						'x-access-token': token
					}
				})
				.then(
					response => {
						console.log("response", response);
						//设置图片样式
						if (response.data && response.data.data) {
							//设置详情
							if (response.data.data.images) {
								this.imgSrc = response.data.data.images[0]
							}
							//设置分享文案
							if (response.data.data.shareDesc) {
								this.shareDesc = response.data.data.shareDesc
							}
						}
					},
					reject => { }
				)
				.catch(function (error) {
					console.log(error);
				});

				axios
				.post(API.ProductTarget, {
					memberId:"",
					productType:productType,
					productId:productId,
					bizType: productBizType

				}, {
					timeout: 5000,
					headers: {
						'x-access-token': token
					}
				})
				.then(
					response => {
						console.log("response", response);
						//设置图片样式
						if (response.data && response.data.data) {
							//设置详情
							console.log('response.data.data', )
							let patharr = response.data.data.split("?src=")
							if(patharr.length) {
								this.mppath = `/${patharr[0]}`
								this.h5path = decodeURIComponent(patharr[1])
							}
						}
					},
					reject => { }
				)
				.catch(function (error) {
					console.log(error);
				});
		},
		share() {
			this.showBottom = true
			console.log(location)
			const sharePath = this.h5path
			// const sharePath = `${location.origin}${location.pathname}#/cpsDetail?productId=${this.$route.query.productId}`
			const currentPath = location.hostname + location.pathname
			//万一不存在呢？
			const shareImg = this.imgSrc
			console.log('分享页面', `${location.href}`)
			console.log('落地H5', `${sharePath}`)
			console.log('分享小程序页面', `${this.mppath}`)
			this.Correspond.ready(() => {
				//1.设置按钮
				this.Correspond.share({
					shareList: [{//list数组，可设置多个按钮
						show: true,//是否显示此按钮
						type: 0,//索引，与下面的btnList数组一致
						shareStyle: 'position: fixed;bottom:30rpx;left: 225rpx;width:300rpx; height: 250rpx;',//外层view的样式，定位需要
						btnStyle: 'width:300rpx; height: 250rpx;opacity:0',//btn按钮样式，宽高与上面的一致即可，宽高是一定要的，不然容器撑不开
					}],
					success(res) {
						console.log('success-res', res)
						//3.关闭分享
						this.closeShare()
					},
					fail(res) {
						console.log('fail-res', res)
					}
				});

				//2.设置分享
				wx.miniProgram.postMessage({
					data: {
						isMiniApp: false, //是否分享小程序链接
						btnList: [{
							currentPath: currentPath,
							title: this.shareDesc, //默认
							imageUrl: shareImg,
							path: sharePath, //分享中转页
							eventTracer: {
								pagename: this.mppath, //页面名称，一个完整的视图的路径
								productcode: 2000, //公共    产品码
								category: 'category', //类型
								action: 'click', //动作
								label: 'cpsshare', //事件名称，静态值（如推送事件：opt_label：push）
								value: 'cpsshare', //事件的参数值，动态值（如同一事件包含多个维度的变量，用特殊符号分割，数据清洗时解析）
								expandfield: 'cpsshare',//项目自定义字段数据
							},
							successObj: {
								//分享成功的回调接口请求，只支持发起请求，不支持请求成功后的回调处理。可不传
								url: '',
								data: {},
								method: 'GET', //默认get请求
								header: {
									'Content-Type': 'application/json',
								}, //默认"Content-Type": "application/json"
							},
						}],
						
						shareInfo: {
							currentPath: currentPath,
							title: this.shareDesc, //默认
							imageUrl: shareImg,
							path: sharePath, //分享中转页
							successObj: {
								//分享成功的回调接口请求，只支持发起请求，不支持请求成功后的回调处理。可不传
								url: '',
								data: {},
								method: 'GET', //默认get请求
								header: {
									'Content-Type': 'application/json',
								}, //默认"Content-Type": "application/json"
							},
						},


					},
				})

			})


		},
		closeShare() {
			this.showBottom = false
			//清空
			this.Correspond.share({
					shareList: [],
					success(res) {
					},
					fail(res) {
					}
			});
		},
		generateRandomString(length) {
			var result           = '';
			var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			var charactersLength = characters.length;
			for (var i = 0; i < length; i++) {
				result += characters.charAt(Math.floor(Math.random() * charactersLength));
			}
			return result;
		}
	}
};
</script>
<style scoped>
.mask {
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	background-color: black;
	z-index: 0;
	-moz-opacity: 0.5;
	opacity: 0.5;
	filter: alpha(opacity=50);
}

.product {
	position: fixed;
	width: 80%;
	margin-left: 10%;
	/* margin-top: 30%; */
	background-color: #fff;
	border-radius: 10px;
	/* height: 350px; */
	box-shadow: 1px 1px 1px 4px rgba(252, 206, 44, 0.05);
}

.product-wrapper {
	position: relative;
}

.top01 {
	position: absolute;
	border: 10px solid transparent;
	border-left: 10px solid #fff;
	width: 0;
	height: 0;
	border-style: dashed dashed solid;
	right: -18px;
	top: 10px;
}

.header-title {
	font-size: 0.4rem;
	margin: 10px;
	margin-top: 0px;
	padding-top: 10px;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: normal;
	font-weight: 600;
	/* text-align: justify; */
}

.header-img {
	display: flex;
	align-items: center;
	flex-direction: row;
	padding: 0 10px;
	padding-top: 15px;
	color: #999;
	font-weight: 600;
	width: 100%;
	box-sizing: border-box;
	overflow: hidden;
	justify-content: space-around;
}

.header-img2 {
	font-size: 16px;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: normal;
	
}

.header-img1 {
	width: 40px;
	padding-right: 5px;
}

.header-img3 {
	width: 60px;
	padding-left: 10px;
}

.header-banner {
	width: 90%;
	margin-left: 5%;
	/* height: 220px; */
	height: 40%;
	margin-bottom: 15px;
}
.header-logo-txt{
	font-weight: 600;
}

.taro-img__mode-aspectfill {
	object-fit: cover;
	width: 100%;
	height: 100%;
}

.header-logo img {
	width: 23px;
}

.header-logo {
	width: 90%;
	margin-left: 5%;
	box-sizing: border-box;
	border-top: 1px solid #eee;
	padding: 5px 0px;
	display: flex;
	align-items: center;
	flex-direction: row;
	font-size: 0.3rem;
	color: #999;
}

.share-btn-wrapper {
	width: 100%;
}

.share-btn {
	position: fixed;
	bottom: 50px;
	width: 220px;
	height: 50px;
	border-radius: 25px;
	background: #ff8324;
	color: #fff;
	font-size: 18px;
	display: flex;
	align-items: center;
	justify-content: center;
	left: 50%;
	transform: translateX(-50%);
	/*水平居中*/
}

.bottom {
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 160px;
	background-color: #fff;
	border-top-right-radius: 10px;
	border-top-left-radius: 10px;
}

.bottom-close-wrapper {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
}

.bottom-close {
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.bottom-close img {
	width: 20px;
	height: 20px;
}

.bottom-img-wrapper {
	display: flex;
	flex-direction: column;
	align-items: center;
	font-size: 20px;
}

.bottom-img {
	width: 80px;
	height: 60px;
}

.bottom-img img {
	width: 80px;
	height: 60px;
}

.bottom-txt {
	padding: 14px;
	font-size: 16px;
}

.poster-loading-wrapper{
  display: flex;
  width: 100%;
  height: 180rpx;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
}
.poster-loading-txt{
    font-size: 14px;
    color: #d1d1d1;
	padding-top: 10px;
  }
.poster-loading,
.poster-loading:before,
.poster-loading:after {
    border-radius: 50%;
}
.poster-loading {
  position: relative;
  width: 46px;
  height: 46px;
  box-shadow: inset 0 0 0 4px #936BFF;
  transition: color 1.3s ease;
  animation: gradientColor 1.3s infinite ease;
}

.poster-loading:before,
.poster-loading:after {
  position: absolute;
  content: "";
  top: 0;
  width: 24px;
  height: 47px;
  background: #fff;
  display: inline-block;
}

.poster-loading:before {
  border-radius: 46px 0 0 46px;
  left: -1px;
  -webkit-transform-origin: 24px 23px;
  transform-origin: 24px 23px;
  -webkit-animation: poster-loading 1.3s infinite ease 1s;
  animation: poster-loading 1.3s infinite ease 1s;
}

.poster-loading:after {
  border-radius: 0 46px 46px 0;
  left: 23px;
  -webkit-transform-origin: 0px 23px;
  transform-origin: 0px 23px;
  -webkit-animation: poster-loading 1.3s infinite ease;
  animation: poster-loading 1.3s infinite ease;
}

@keyframes poster-loading {
  0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
  }
  100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
  }
}

@keyframes gradientColor {
  0% {
      box-shadow: inset 0 0 0 4px #936BFF;
  }
  100% {
      box-shadow: inset 0 0 0 4px #764ce7;
  }
}

</style>



// WEBPACK FOOTER //
// src/page/cpsShare.vue